import React from "react";

const DeleteAccount = () => {
  return (
    <div style={{maxWidth:"900px",margin:"40px auto",padding:"20px"}}>
      <h1>Delete Your Pitics Account</h1>

      <p>
        If you wish to delete your Pitics account and associated data,
        you can do so directly from the app.
      </p>

      <h2>Steps to Delete Your Account</h2>

      <ol>
        <li>Open the Pitics app</li>
        <li>Sign in to your account</li>
        <li>Go to Account Settings</li>
        <li>Select "Delete Account"</li>
        <li>Confirm the deletion request</li>
      </ol>

      <h2>Data Deletion</h2>

      <p>
        When your account is deleted, the following data will be removed:
      </p>

      <ul>
        <li>User account information</li>
        <li>Personal profile data</li>
        <li>Saved designs</li>
      </ul>

      <p>
        Some order records may be retained for legal or accounting purposes.
      </p>

      <h2>Need Help?</h2>

      <p>
        If you cannot access your account, please contact us:
      </p>

      <p>
        Email: support@pitics.com
      </p>
    </div>
  );
};

export default DeleteAccount;